

<script setup>
  import { defineEmits, defineProps, ref } from 'vue';
  import i18n from '@/i18n'
  import { CONTEXT } from '@/const';
  import service from '@/service';

  const baseUrl = `${location.protocol}${location.host}`;

  // type: userAgreement / privacyStatement
  const props = defineProps({ dialogVisible: Boolean, type: String });
  const emit = defineEmits(['onClose']);

  const privacyStatementContent = ref('');
  const userAgreeStatementContent = ref('');
  const logonLogo = ref('');
  const headerStyle = `background: url(${baseUrl}${CONTEXT.uniportal}/images/header_bg.gif)  left top;`;
  const closeBtnStyle = `background: url(${baseUrl}${CONTEXT.uniportal}/images/bt_bg.gif) left top;`;
  // const backBtnTxt = $t('backButton');

  const useContentInit = ()=>{
        const getLogonLogo= async()=> {
        const res = await service.getLogonLogo();
        const reader = new FileReader();
        reader.onload = e => {
          logonLogo.value = e.target.result;
        };
        reader.readAsDataURL(res.data);
      };

      const getPrivacyStatementContent =()=> {
        service.getPrivacyStatement().then( res => {
          privacyStatementContent.value = res?.content || ''; 
        });
      };

      const getUserAgreementContent=()=> {
        service.getUserAgreement().then( res => {
          userAgreeStatementContent.value = res?.content || ''; 
        })
      };

      return {getLogonLogo, getPrivacyStatementContent, getUserAgreementContent};
  }

  const {getLogonLogo, getPrivacyStatementContent, getUserAgreementContent} = useContentInit();
  getLogonLogo();
  getPrivacyStatementContent();
  getUserAgreementContent();

</script>

<template>
<!-- 隐私声明和用户协议。因为是挂在UserAgreements上的，所以zIndex要保证比UserAgreements大 -->
  <el-dialog :visible= "props.dialogVisible" zIndex="20000"
    :fullscreen="true" 
    :show-close="false"
    :append-to-body="true"
    custom-class="privacy-and-user-dialog">
      <div style="height: 100%;">
        <div class="privacy-dialog-header header-and-button-bg">
          <div style="height:22px; margin-left: 20px;">
            <img style="height: 100%; object-fit: contain;" :src="logonLogo" alt=""/>
          </div>
        </div>
        <div style="height: 100%; margin-top: 8px;">
          <div v-if="type==='userAgreement'" v-html="userAgreeStatementContent" class="dialog-content" ></div>
          <div v-if="type==='privacyStatement'" v-html="privacyStatementContent" class="dialog-content" ></div>
          <div style="position: fixed; bottom: 8px; width: 100%;">
            <div class="dialog-close-btn header-and-button-bg" @click="()=>emit('onClose')">{{ $t('backButton') }}</div>
          </div>
        </div>
        <i18n>{{userAgreeStatementContent}}</i18n>
      </div>
  </el-dialog>
</template>

<style lang="less" >
.privacy-and-user-dialog{
  overflow: hidden !important;
}
.privacy-and-user-dialog .el-dialog__header {
  padding: 0;
}
.privacy-and-user-dialog .el-dialog__body {
  height: 100%;
  padding: 0;
  color: #000;
}
.privacy-and-user-dialog .dialog-content {
  padding: 0 20px;
  overflow-y: scroll;
  height: calc(100% - 60px - 29px - 28px);
}
.privacy-and-user-dialog .privacy-dialog-header {
  height: 63px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #aeaeae;
}
.privacy-and-user-dialog .dialog-close-btn {
  line-height: 29px;
  height: 29px;
  width: 95px;
  cursor: pointer;
  border: 0 none;
  font-weight: bolder;
  color: #000;
  font-size: 14px;
  display: block;
  margin: auto;
  text-align: center;
  border: 1px solid #aeaeae;
  border-radius: 2px;
}
.header-and-button-bg {
  background: linear-gradient(to top, rgb(229, 229, 229), rgb(247, 247, 247));
}
</style>